<template>
  <div>
    <div v-if="view">
      <div class="col-md-8 col-md-offset-2">
        <div v-if="!optionsArray.length">
          <h4 class="text-center">{{computeCaption(fields_en['no_patients'], $store.state.lang.value.toLowerCase())}}</h4>
        </div>
        <!-- dependent -->
        <div v-if="optionsArray.length <= 4 && optionsArray.length > 0" class="row mt-5" :class="[validatedSectionClass, generalClass]">
          <div class="col-md-2 col-md-offset-1">
            <div class="form-group mt-10 mb-0">
              <label
                class="control-label"
                :class="
                  modelValidations.dependent['required'] ? 'required' : ''
                "
                for="dependent"
              >
                {{computeCaption(fields_en['patient'], this.$store.state.lang.value.toLowerCase())}}
              </label>
            </div>
          </div>
          <div class="col-md-8 patient-float">
            <div class="form-group">
              <el-radio-group
                size="small"
                data-vv-as="Dependent"
                id="Dependent"
                v-validate="modelValidations.dependent"
                placeholder="Single Select"
                name="Dependent"
                v-model="model.dependent"
              >
                <el-radio-button
                  v-for="option in optionsArray"
                  :value="option.name"
                  :label="option.name"
                  :key="option.name"
                  tabindex="0"
                >{{option.name === 'Self' ? computeCaption(fields_en['self'], $store.state.lang.value.toLowerCase()) : option.name}}
                </el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <small class="text-danger col-md-0" v-show="dependent.invalid">
                {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
        </div>

        <div v-if="optionsArray.length > 4" class="row" :class="[validatedSectionClass, generalClass]">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <label
                class="control-label"
                :class="
                  modelValidations.dependent['required'] ? 'required' : ''
                "
                for="dependent"
              >
                {{computeCaption(fields_en['patient'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-select
                size="large"
                id="member1"
                data-vv-as="Dependent"
                v-validate="modelValidations.dependent"
                placeholder="Single Select"
                name="gender"
                v-model="model.dependent"
              >
                <el-option
                  v-for="option in optionsArray"
                  class="select-danger"
                  :value="option['name']"
                  :label="option['name'] === 'Self' ? computeCaption(fields_en['self'], $store.state.lang.value.toLowerCase()) : option['name']"
                  :key="option['name']"
                >
                </el-option>
              </el-select>
            </div>
            <small class="text-danger" v-show="dependent.invalid">
              {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>

          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <small class="text-danger col-md-0" v-show="dependent.invalid">
                {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div v-if="newDependentSelected">
          <GoPass logged="true" ref="goPass">
            </GoPass>
            </div>
        </transition>
        <br/>
      <div class="row" v-if="newDependentSelected && hideButton">
        <div class="col-md-12 bg-white">
          <button
            v-on:click.stop.prevent="seeResults()"
            class="btn btn-fill btn-wd btn-next w-100 text-center"
          >
            {{computeCaption(fields_en['see_results'], $store.state.lang.value.toLowerCase())}}
          </button>
        </div>
      </div>
      <br/>

        <div class="row">
          <div class="col-md-10 button-container">
            <button
              class="btn btn-default btn-wd btn-back primary-color back-button"
              v-on:click.stop.prevent="
                $router.push({ path: '/patient/account' })
              "
            >
              <span>
                {{computeCaption(fields_en['back'], this.$store.state.lang.value.toLowerCase())}}
              </span>
            </button>
          </div>
        </div>
        <br /><br />
      </div>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import {Autocomplete, Input, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import ConsentDisclaimer from '../../Utils/Sections/ConsentDisclaimer.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  import GoPass from '../../GoPass/GoPassLayout.vue'
  require('cleave.js/dist/addons/cleave-phone.us')
  export default {
    components: {
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      [CheckboxButton.name]: CheckboxButton,
      [CheckboxGroup.name]: CheckboxGroup,
      ConsentDisclaimer,
      GoPass
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
    data () {
      return {
        hideButton: true,
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        disabledButton: false,
        signature: '',
        submit: false,
        view: false,
        newDependentSelected: false,
        finalResponse: {},
        dependentError: '',
        optionsArray: [],
        suggestions: [],
        answers_es: {},
        answers_zh: {},
        requirements: [],
        questionError: '',
        errorDate: '',
        errorSave: '',
        client_bill_translation: '',
        paymentMethod: 'card',
        questionErrorDate: [],
        answer_no: 'No',
        amount: this.$store.state.configs.PAYMENT_AMOUNT,
        allow_payment: this.isTrue(this.$store.state.configs.ALLOW_PAYMENT),
        allow_insurance_card: this.isTrue(this.$store.state.configs.ALLOW_INSURANCE_CARD),
        required_insurance_card: this.isTrue(this.$store.state.configs.REQUIRED_INSURANCE_CARD),
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        display_order_barcode: this.$store.state.configs.DISPLAY_ORDER_BARCODE,
        fields_en: {
          self: 'Self',
          no_patients: 'None of the patients linked to this account meet the minimum requirements for this feature',
          see_results: 'See Results',
          back: 'Back',
          register: 'Register',
          note: 'Note',
          patient: 'Select patient'
        },
        model: {
          dependent: ''
        },
        modelValidations: {
          dependent: {
            required: true
          }
        }
      }
    },
    methods: {
      redirectHome () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.href = window.origin + '/#/'
          window.location.reload()
        }
      },
      async prepareData () {
        let one = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
        let two = process.env.SERVER_URI + '/account/get/dependents'
        let three = process.env.SERVER_URI + '/account/check/user'
        // let four = process.env.SERVER_URI + '/getExternalCode/' + this.$store.state.sitecode
        let email = localStorage.getItem('email')
        const requestOne = axios.get(one)
        const requestTwo = axios.post(two, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestThree = axios.post(three, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        // const requestFour = axios.get(four)
        await axios.all([requestOne, requestTwo, requestThree])
            .then(axios.spread((...responses) => {
              this.$store.state.site = responses[0].data
              if (responses[2].data === false) {
                this.$store.state.userData = {
                  driver_license_image: '',
                  driver_license_name: '',
                  firstName: '',
                  lastName: '',
                  passport: '',
                  dob: '',
                  dob_pretty: '',
                  address: '',
                  address2: '',
                  gender: '',
                  phone: '',
                  race: '',
                  ethnicity: '',
                  addressComponents: '',
                  primary_insurance: '',
                  policy_number: '',
                  group_number: '',
                  driver_license_number: '',
                  social_number: '',
                  external_code: ''
                }
              } else if (responses[2].data) {
                this.$store.state.userData = {
                  firstName: responses[2].data['first_name'] || '',
                  lastName: responses[2].data['last_name'] || '',
                  passport: responses[2].data['passport'] || '',
                  dob: responses[2].data['date_of_birth'] || '',
                  dob_pretty: responses[2].data['date_of_birth'] || '',
                  address: responses[2].data['address'] || '',
                  address2: '',
                  gender: responses[2].data['gender'] || '',
                  phone: responses[2].data['phone'] || '',
                  race: responses[2].data['race'] || '',
                  ethnicity: responses[2].data['ethnicity'] || '',
                  external_code: responses[2].data['external_code'] || ''
                }
              }
              if (responses[1].data === false) {
                this.$store.state.dependentsData = []
              } else if (responses[1].data) {
                this.$store.state.dependentsData = responses[1].data
              }
              this.$store.state.patientRegistrationData = this.$store.state.userData
              this.$store.state.userData = {
                driver_license_image: '',
                driver_license_name: '',
                firstName: '',
                lastName: '',
                passport: '',
                dob: '',
                dob_pretty: '',
                address: '',
                address2: '',
                gender: '',
                phone: '',
                race: '',
                ethnicity: '',
                addressComponents: '',
                primary_insurance: '',
                policy_number: '',
                group_number: '',
                driver_license_number: '',
                social_number: ''
              }
              this.view = true
              return true
            })).catch(error => {
              console.log(error)
              this.view = false
              return false
            })
      },
      seeResults () {
        this.$refs.goPass.callValidation()
        this.hideButton = false
      }
    },
    computed: {
      ...mapFields(['dependent'])
    },
    watch: {
      'model.dependent': {
        handler: function (after, before) {
          if (this.model.dependent) {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          }
          this.dependentError = ''
          if (this.model.dependent === 'Self') {
            this.$store.state.userData = this.$store.state.patientRegistrationData
            this.$store.state.dependentSelected = false
          } else {
            this.$store.state.dependentSelected = true
            let id
            for (id in this.$store.state.dependentsData) {
              if (this.model.dependent === this.$store.state.dependentsData[id]['first_name'] + ' ' + this.$store.state.dependentsData[id]['last_name']) {
                this.dependentsArray = this.$store.state.dependentsData
                this.$store.state.userData = {
                  firstName: this.dependentsArray[id]['first_name'] || '',
                  lastName: this.dependentsArray[id]['last_name'] || '',
                  dob: this.dependentsArray[id]['date_of_birth'] || '',
                  dob_pretty: this.dependentsArray[id]['date_of_birth'] || '',
                  gender: this.dependentsArray[id]['gender'] || '',
                  phone: this.dependentsArray[id]['phone'] || '',
                  race: this.dependentsArray[id]['race'] || '',
                  ethnicity: this.dependentsArray[id]['ethnicity'] || '',
                  id: this.dependentsArray[id]['id'],
                  external_code: this.dependentsArray[id]['external_code'] || ''
                }
              }
            }
          }
          this.newDependentSelected = false
          this.$nextTick(() => {
            this.newDependentSelected = true
            this.hideButton = true
          })
        }
      },
      '$store.state.requirements': {
        handler (update) {
          delete this.$store.state.requirements['ethnicity']
          delete this.$store.state.requirements['gender']
          delete this.$store.state.requirements['race']
        },
        immediate: true
      }
    },
    async beforeMount () {
      await this.prepareData()
      if (this.$store.state.patientRegistrationData['external_code'] && this.$store.state.patientRegistrationData['external_code'] !== '') {
        this.optionsArray.push({name: 'Self'})
        this.model.dependent = 'Self'
      }
      let id
      for (id in this.$store.state.dependentsData) {
        if (this.$store.state.dependentsData[id]['external_code'] && this.$store.state.dependentsData[id]['external_code'] !== '') {
          this.optionsArray.push({name: this.$store.state.dependentsData[id]['first_name'] + ' ' + this.$store.state.dependentsData[id]['last_name']})
        }
      }
      if (this.optionsArray.length && this.model.dependent === '') {
        this.model.dependent = this.optionsArray[0].name
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";
.w-100 {
  width: 100%;
}
.btn-next {
  border: 1px solid $primary-color !important;
  border-radius: 3px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/GoPassLogged.vue